module.exports = "../../app/cells/pages/questions/freemium_limit_bottom_bar_cell.rb";